import React, { useContext, useEffect, useState } from 'react';
import CarItem from '../Item';
import { useCar } from '../../../../hooks/useCar'
import Report from './Report/Report';
import crl from './CarList.module.css'
import { AppContext } from "../../../../providers/appProvider"
import ErrorModal from '../../../UI/ErrorModal/ErrorModal';
import CarSearch from '../Search/CarSearch';
import Pagination from '../../../UI/Pagination/Pagination';
import TotalPrice from '../TotalPrice/TotalPrice';
import Table from "../../../../assets/Icon/Table";
import Refresh from "../../../../assets/Icon/Refresh";
import List from "../../../../assets/Icon/List";
import Excel from "../../../../assets/Icon/Excel";
import PdfIcon from "../../../../assets/Icon/PdfIcon";
import tbl from '../../../../assets/Style/Table.module.css'
import { useAuth } from '../../../../providers/authProvider';
import TableParams from '../TableParams/TableParams';
import { useUpdateEffect } from '../../../../hooks/useUpdateEffect';
import Plus from '../../../../assets/Icon/Plus';
import { useTranslation } from 'react-i18next';
  
const CarList = () => {
  const { t } = useTranslation();
  
  const { carService } = useCar(100);
  const { appState, app } = useContext(AppContext);
  const { session, setStoredFunctionRef, isRole } = useAuth()
 
  const [columns, setColumns] = useState({
    id: true,
    vin: true,
    client: true,
    contact: true,
    purchased: true,
    car: true,
    website: true,
    agentcrm: true,
    saler: true,
    dealer: true,
    bl_number: true,
    container: true,
    transit: true,
    sender: true,
    sender_at: true,
    reciever_at: true,
    reciever: true,
    export_country: true,
    dealerPrice: true,
    insurance: true,
    status: true,
    doc_issue: true,
    final_recipient: true,
    percent: true,
    archive: true,
    client_discount:true,
    company_discount:true,
    marine_line: true,
    feedback: true,
  });

  useUpdateEffect(() => {
    localStorage.setItem('columns', JSON.stringify(columns));
  }, [columns]);

  useEffect(() => {
    const savedVisibility = localStorage.getItem('columns');

    if (savedVisibility) {

      const savedColumns = JSON.parse(savedVisibility);
      setColumns((currentColumns) => ({
        ...currentColumns,
        ...savedColumns,
        agentcrm: savedColumns.agentcrm ?? true,
      }));
    }
  }, []);


  
  useEffect(() => {
    const myFunc = () => {
      carService.resetDefault()
      app.setupDefault()
    };
    //app.setupDefault()
     setStoredFunctionRef(myFunc);
  }, [carService]);


  useEffect(() => { 

     app.setupDefault() 
  }, []);

  const toggleSwitcher = () => {
    app.setIsTableRevert();
  };

  const downloadExcel = () => {
     carService.downloadExcel()
  };

  const downloadPdfBonus = () => {
     carService.downloadPdfBonus()
  };

  const handleRefresh = (event) => { 
    
    carService.resetDefault()
    app.setupDefault()

  };


  if (!appState.isLoaded) {
    return null; 
}

  return <div>


    <div className={crl.headMain}>
      <div className={crl.headflex}> 
        <h1>{t('Finances')}</h1> 
      </div>
      <TotalPrice sum={carService.sum} />
    </div>
 
 

    <Pagination total={carService.totalCars}
      perPage={carService.filter.limit}
      current={carService.filter.page}
      paginate={(page) => { 
        carService.setFilter({
          ...carService.filter,
          page: page,
        });
      }}
      setLimit={(limit) => {
        carService.setFilter({
          ...carService.filter,
          limit: limit,
        });
      }}
    >
 
<div style={{ color: "var(--primary-color)", fontWeight: "700", marginRight: "15px", display: "flex", alignItems: "center" }}>
/ {carService.totalPaidCars}</div>
         

        <div style={{display: 'flex', alignItems: 'center', gap: '5px'}}>

          { app.hasPermission("FINANCE_ADD") &&
          <>  

           <a href="/finances/add" target="_blank" className={crl.AddBtn}>
              <span className={crl.icon}> <Plus /> </span>
              <span className={crl.text}>{t('Add')}</span>
          </a>

            </>
          }
          

          { app.hasPermission("EXPORT_EXCEL") &&
          <>  
            <span  onClick={downloadExcel} className={crl.exelBtn}>
                <span className={crl.icon} > <Excel /></span>
                <span className={crl.text} > {t('Export')} </span>
                
            </span> 
          </>
          }

          { app.hasPermission("EXPORT_EXCEL_REPORT") &&
            <>  
               <Report carService={carService}> </Report>
            </>
          }


          { app.hasPermission("EXPORT_PDF_BONUS") &&
            <>  
                
              <span onClick={downloadPdfBonus}  className={crl.exelBtn} >
                  <span className={crl.icon} > <PdfIcon /></span>
                  <span className={crl.text} >{t('Bonus')}</span>
              </span> 
 
 
            </>
          }

           
          {
            app.hasPermission("LIST_SHOW") && 
            <div style={{display: 'flex', alignItems: 'center', gap: '5px'}}>

              {appState.isTable ? (
                <span className={crl.switcher} onClick={toggleSwitcher}>
                  <List />  
                </span>
              ) : (
                <span className={crl.switcher} onClick={toggleSwitcher}>
                  <Table />  
                </span>

              )}

              {appState.isTable && (
                <TableParams columns={columns} setColumns={setColumns} />
              )}   
            </div>
  
          }


          <span className={crl.switcher} onClick={handleRefresh}>
            <Refresh />  
          </span>

          </div>
         

 
      </Pagination>


      <div className={crl.head}  >
      <CarSearch isTable={null} carService={carService} />
    </div>
    
    {appState.isTable ? (
      <div className={tbl.table + ' ' + crl.table} style={{ height: 'calc(100vh - 206px)', background: 'white', position: 'relative' }}>
        <table style={{   borderCollapse: 'separate', borderSpacing: 0, tableLayout: 'fixed'}}>
 
          {appState.isTable && <CarSearch isTable={appState.isTable} carService={carService} columns={columns} />}

          <tbody>
            {carService.cars.map((car, index) =>
              <CarItem   
                key={index}
                carItem={car}
                carService={carService}
                statuses={appState.statuses} 
                isTable={appState.isTable}
                columns={columns}
              />)}
          </tbody>
        </table>

      </div>
    ) : (
      <div>
        {carService.cars.map((car, index) =>
          <CarItem 
            key={index}
            carItem={car}
            carService={carService}
            statuses={appState.statuses}
            isTable={appState.isTable}
          />)}
      </div>
    )}
 
    {appState.error && <ErrorModal message={appState.error} onClose={() => app.clearError(false)} />}

    <Pagination total={carService.totalCars}
      perPage={carService.filter.limit}
      current={carService.filter.page}
      paginate={(page) => { 
        carService.setFilter({
          ...carService.filter,
          page: page,
        });
      }}
      setLimit={(limit) => { 
        carService.setFilter({
          ...carService.filter,
          limit: limit,
        });
      }}
    />
  </div>;
}

export default CarList;





 
